<template>
  <v-layout
    column
    fill-height
    justify-center
  >
    <v-flex
      xs12
      md12
      sm12
    >
      <v-layout
        align-end
        justify-end
        row
        wrap
      >
        <v-flex
          xs12
          md4
          sm5
        >
          <a @click="getTextAds(businessDetails)" class="text-end pr-1 pb-1" v-show="!hasLessThanThreeServices">
            <v-icon color="primary">
              refresh
            </v-icon>
            <span class="body-1 ml-1 font-weight-bold">
              {{ $t('message.bizgainOnboarding.moreExamples') }}
            </span>
          </a>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex
      xs12
      md12
      sm12
    >
      <v-layout
        row
        wrap
        :class="{'justify-space-around':$vuetify.breakpoint.lgAndUp,'justify-center':$vuetify.breakpoint.mdAndDown}"
      >
        <v-flex
          xs12
          v-for="(ad, index) in textAds"
          :key="index"
          :class="{
            'py-2 pl-1 pr-2': index % 2 == 0 && !$vuetify.breakpoint.xsOnly,
            'py-2 pr-1 pl-2': index % 2 != 0 && !$vuetify.breakpoint.xsOnly,
            'py-2 px-1': $vuetify.breakpoint.xsOnly,
            'lg6 md10 sm11':!isDashboardLayout && !isSummary,'md6':isSummary,'lg12':isDashboardLayout
          }"
        >
          <leads-objective-template
            v-if="isLeadsObjective"
            :ad="ad"
            :text-ad="textAd"
            :website-url="websiteUrl"
          />
          <call-objective-template
            v-else-if="isCallsObjective"
            :ad="ad"
            :text-ad="textAd"
            :website-url="websiteUrl"
            :mobile-number="businessDetails.mobileNumber"
          />
          <other-objectives-template
            v-else
            :ad="ad"
            :text-ad="textAd"
            :website-url="websiteUrl"
          />
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>
<script>
import {
  VLayout,
  VFlex,
  VIcon
} from 'vuetify/lib';
import { mapGetters, mapActions } from 'vuex';
import { bizgainOnboardingImage } from '../../../constants.js';
import { businessDetailsMacros } from 'Features/bizgainOnboarding/constants';
import { bizgainOnboardingRoutes, objectiveType, launchState } from 'Features/bizgainOnboarding/constants';
import CallObjectiveTemplate from './CallsObjectiveTemplate.vue';
import OtherObjectivesTemplate from './OtherObjectivesTemplate.vue';
import LeadsObjectiveTemplate from './LeadsObjectiveTemplate.vue';
export default {
  created() {
    this.services = this.promoteServices;
    this.isSingleServiceSelected = Array.isArray(this.services) && this.services.length === 1;
    this.getTextAds(this.businessDetails);
  },
  components: {
    VLayout,
    VFlex,
    VIcon,
    CallObjectiveTemplate,
    OtherObjectivesTemplate,
    LeadsObjectiveTemplate
  },
  data() {
    return {
      services: [],
      descriptionNo: 1,
      serviceNo: 0,
      textAds: [],
      globeImg: bizgainOnboardingImage.globe,
      bizgainOnboardingRoutes,
      isSingleServiceSelected: false,
      objectiveType,
      isUpdateLaunchState: false,
      launchState
    }
  },
  props: {
    isSummary: {
      default: null,
      type: Boolean
    },
    editedBusinessDetails: {
      default: null,
      type: Object
    },
    adCount: {
      default: 4,
      type: Number
    },
    isDashboardLayout: {
      default: false,
      type: Boolean
    }
  },
  methods: {
    ...mapActions(['updateBusinessDetails', 'patchBusinessDetails']),
    getTextAds(businessDetails) {
      let count = this.adCount;
      this.textAds = [];
      if(Array.isArray(this.services) && this.services.length === 1) {
        count = 2;
      }
      let details = businessDetails.creativeDetail.adDetail.textAd;
      for(let i = 0; i < count; i++) {
        let description = this.descriptionNo == 1 ?  details.description1 : details.alternativeDescription1
        let macro = description.includes(businessDetailsMacros.services) ? businessDetailsMacros.services : businessDetailsMacros.alternateServices;
        if(!this.isSingleServiceSelected || description.includes(macro)){
          description = description.replace(macro, this.services[this.serviceNo]);
        }
        this.textAds.push({ description })
        this.serviceNo = (this.serviceNo + 1) % this.services.length;
        if(this.serviceNo == 0 && this.services.length % 2 == 0) {
          this.services.unshift(this.services.pop());
        }
        this.descriptionNo = this.descriptionNo == 1 ? 2 : 1;
      }
    }
  },
  computed: {
    ...mapGetters(['businessDetails', 'promoteServices', 'objective', 'isInAppCampaign', 'roimaticCampaignId', 'businessProfileId', 'googlePlaceDetails']),
    textAd(){
      return this.businessDetails.creativeDetail.adDetail.textAd;
    },
    hasLessThanThreeServices(){
      return this.services && this.services.length <= 2;
    },
    isCallsObjective(){
      return this.objective === this.objectiveType.calls.id;
    },
    isLeadsObjective(){
      return this.objective === this.objectiveType.leadGeneration.id;
    },
    websiteUrl(){
      if (this.businessDetails.landingPage) {
        return this.businessDetails.landingPage;
      } else if (this.businessDetails.websiteUrl) {
        return this.businessDetails.websiteUrl;
      }  else if (this.googlePlaceDetails && this.googlePlaceDetails.website) {
        return this.googlePlaceDetails.website;
      } else {
        return 'www.yourwebsite.com';
      }
    }
  },
  watch: {
    editedBusinessDetails(newValue){
      this.getTextAds(newValue);
    }
  }
}
</script>

<style lang="scss" scoped>

  .text-end {
    text-align: end;
  }
</style>